import { render, staticRenderFns } from "./AddressWindow.vue?vue&type=template&id=b4fa5724&scoped=true&lang=pug&"
import script from "./AddressWindow.vue?vue&type=script&lang=ts&"
export * from "./AddressWindow.vue?vue&type=script&lang=ts&"
import style0 from "./AddressWindow.vue?vue&type=style&index=0&id=b4fa5724&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa5724",
  null
  
)

export default component.exports